import { FetchOperationalExpensesParams } from "../../../apis/drayage/types";
import { SortFilterDirectionsEnum } from "../../../types/drayage";
import { OperationExpensesColumnNamesEnum } from "../../Drayage/Search/Search.data";

export const initialOEParams: FetchOperationalExpensesParams = {
  operationalExpensesProfileName: "",
  pagination: {
    pageNumber: 1,
    pageSize: 512,
    includeTotalRecords: true,
  },
  sorting: {
    sortBy: OperationExpensesColumnNamesEnum.name,
    sortDirection: SortFilterDirectionsEnum.Ascending,
  },
};
